module.exports = __webpack_public_path__ + "img/drawer_box1.c185d657.png";